/**
################################
 * Component geeg_woo_filter
 * Built with Maciste / Version 2.0
################################
*/


'use strict';

jQuery(document).ready(function ($) {

        $('#filter').submit(function(){
            var filter = $('#filter');
            $.ajax({
                url:filter.attr('action'),
                data:filter.serialize(), // form data
                type:filter.attr('method'), // POST
                beforeSend:function(xhr){
                    filter.find('button').text('Processing...'); // changing the button label
                },
                success:function(data){
                    filter.find('button').text('Apply filter'); // changing the button label back
                    $('.products').html(data); // insert data
                }
            });
            return false;
        });

});

